import Bowser, { OS_MAP, BROWSER_MAP } from 'bowser' // eslint-disable-line
import { logger } from './logger'

const bowser = Bowser.getParser(window.navigator.userAgent)
const info = Bowser.parse(window.navigator.userAgent)

const showClipboardButton = (bowser.satisfies({
  macos: {
    safari: '>=13'
  }
}) || false)

const safariWithVP8Codec = (bowser.satisfies({
  macos: {
    safari: '>=12'
  }
}) || false)

const browser = bowser.getBrowser()

const isChrome = bowser.getBrowserName(true) === 'chrome'
const isFirefox = bowser.getBrowserName(true) === 'firefox'
const isEdge = bowser.getBrowserName(true) === 'microsoft edge'
const isSafari = bowser.getBrowserName(true) === 'safari'
logger('BROWSER - ', browser, 'safariWithVP8Codec', safariWithVP8Codec, 'isSafari', isSafari)

export {
  info,
  showClipboardButton,
  safariWithVP8Codec,
  browser,
  isChrome,
  isFirefox,
  isEdge,
  isSafari,
}

